<template>
    <div class="brands">
        <img class="img-fluid" src="../assets/logostiendas.png" alt="">
    </div>
</template>

<script>
    export default {

    }
</script>

<style scoped>
.brands{
    padding: 50px 0;
}

img{
    width: 100%;
}

</style>